"use strict";
/**
 * The scheduled auto-scan configuration contract: which scopes are enrolled
 * in scheduled scanning, which mode(s) run per scope, and the cadence/batch
 * knobs that bound one scheduled run. Defined once here so a
 * Terraform-declared SSM parameter's shape and the Lambda-side reader can
 * never drift apart — the same "declare the shared contract once, read it
 * everywhere" discipline this package already applies to the GHE
 * budget-state contract (see `ghe-budget.ts`).
 *
 * One SSM parameter holds this document as a JSON string. Exactly one module
 * on the Lambda side parses it; see that module's doc for the safe-default
 * and distinguishable-failure behavior applied to a missing or malformed
 * value.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=autoscan-config.js.map